import { useCallback } from 'react';
import { useRequestMentions } from 'ui';
import { useCommunityUsersAutocompleteMutation } from '../queries/mutations';

export const useCommunityMentions = (getCommunityId: () => string | undefined) => {
  const { mutateAsync: requestCommunityMentions } = useCommunityUsersAutocompleteMutation();

  const onRequestMentions = useCallback(
    async (value: string) => {
      const communityId = getCommunityId();

      return communityId ? requestCommunityMentions({ communityIds: [communityId], limit: 5, search: value }) : [];
    },
    [getCommunityId, requestCommunityMentions],
  );

  return useRequestMentions(onRequestMentions);
};
